enum ReportStatus {
  NONE = "none",
  FINISHED = "finished",
  FREE = "free",
  BASIC = "basic",
  COMPREHENSIVE = "comprehensive",
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
  ANNUAL = "annual",
  PREMIUM = "premium",
  CANCELED = "canceled",
  REFUND = "refund"
}

export const ReportStatusValues: ReportStatus[] = [
  ReportStatus.NONE,
  ReportStatus.FINISHED,
  ReportStatus.FREE,
  ReportStatus.BASIC,
  ReportStatus.COMPREHENSIVE,
  ReportStatus.MONTHLY,
  ReportStatus.QUARTERLY,
  ReportStatus.ANNUAL,
  ReportStatus.PREMIUM,
  ReportStatus.CANCELED,
  ReportStatus.REFUND
]

export const ActiveSubscriptionReportStatusValues: ReportStatus[] = [
  ReportStatus.MONTHLY,
  ReportStatus.QUARTERLY,
  ReportStatus.ANNUAL
]

export default ReportStatus
